/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './physio-order.reducer';

export const PhysioOrderDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const physioOrderEntity = useAppSelector(state => state.physioOrder.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="physioOrderDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.physioOrder.detail.title">PhysioOrder</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.physioOrder.id">Id</Translate>
            </span>
          </dt>
          <dd>{physioOrderEntity.id}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.physioOrder.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{physioOrderEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.physioOrder.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{physioOrderEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.physioOrder.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{physioOrderEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.physioOrder.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{physioOrderEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.physioOrder.active">Active</Translate>
            </span>
          </dt>
          <dd>{physioOrderEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="recomendation">
              <Translate contentKey="tinyMedicRestApp.physioOrder.recomendation">Recomendation</Translate>
            </span>
          </dt>
          <dd>{physioOrderEntity.recomendation}</dd>
          <dt>
            <span id="orderStatus">
              <Translate contentKey="tinyMedicRestApp.physioOrder.orderStatus">Order Status</Translate>
            </span>
          </dt>
          <dd>{physioOrderEntity.orderStatus}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.physioOrder.treatmentPlan">Treatment Plan</Translate>
          </dt>
          <dd>{physioOrderEntity.treatmentPlan ? physioOrderEntity.treatmentPlan.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.physioOrder.fulfilledBy">Fulfilled By</Translate>
          </dt>
          <dd>{physioOrderEntity.fulfilledBy ? physioOrderEntity.fulfilledBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.physioOrder.createdBy">Created By</Translate>
          </dt>
          <dd>{physioOrderEntity.createdBy ? physioOrderEntity.createdBy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/physio-order" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/physio-order/${physioOrderEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PhysioOrderDetail;
